import { LoginPageContainer } from 'components/loginPage/LoginPageContainer';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LoadingImage } from 'ui-toolkit';
import { ClientUrlFactory } from 'ui-toolkit/rest/ClientUrlFactory';
import { userTypeCookieName } from 'ui-toolkit/authentication/data/userTypeCookieName';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';

export const Auth0ChangePasswordContainer: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    const userTypeFromCookie = Cookies.get(userTypeCookieName) as any;
    if (!userTypeFromCookie || userTypeFromCookie === eAccessControlUserType.None) {
      history.push(window.location.origin);
    } else {
      history.push(ClientUrlFactory().urlFor.spaLogin(userTypeFromCookie));
    }
  }, [history]);
  return (
    <LoginPageContainer>
      <LoadingImage />
    </LoginPageContainer>
  );
};
